module.exports = __webpack_public_path__ + "img/troublebrewing-banner.746d875f.jpg";